<div class="note-input" [ngClass]="{'ticket-note-input' : chatType === 'ticket'}">
  <mat-tab-group class="" (selectedIndexChange)="tabChange($event)" *ngIf="showInternalExternalSelect">
    <mat-tab label="Internal note"></mat-tab>
    <mat-tab label="External note" *ngIf="showExternalNotes"></mat-tab>
  </mat-tab-group>

  <div class="select-bar" *ngIf="showForBar && showRecipient && isExternal && _recipients?.length > 0">
    For
    <ng-container *ngIf="_recipients?.length > 1 else onlyOne">
    <mat-form-field id="owner_filter">
      <mat-select [formControl]="getFormControl('recipientControl')" placeholder="">
        <mat-option *ngFor="let owner of _recipients" [value]="owner.entityId">
          {{ owner.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </ng-container>
    <ng-template #onlyOne>
      {{_recipients[0].value}}
    </ng-template>
  </div>


  <div class="NgxEditor__Wrapper">
<!--    <ngx-editor-menu [editor]="editor"></ngx-editor-menu>-->
    <ngx-editor
      [editor]="editor"
      [formControl]="getFormControl('newNoteControl')"
      [disabled]="disabled"
      [placeholder]="label"
      class="editor"
    ></ngx-editor>
  </div>
  <div class="file-drop" [ngClass]="{'small-file-drop': chatType === 'ticket' && activeFilesCount === 0 && !filesLoading}">
    <home365-multiple-files-upload
      [title]="''"
      [entityType]="'note'"
      [category]="eFileUploadCategories.customerSuccess"
      (someFilesAreBeingUploaded)="filesAreBeingLoaded($event)"
      [formControl]="getFormControl('multipleFiles')"
      [supportedFileTypesAndSizes]="supportedFileTypesWithSize"
      [descriptionText]="uploadFilesText"
      [showCarousel]="true"
      [clickUpload]="clickUpload"
      [useNoteTemplate]="true"
      [maxCellsVisibleOnCarousel]="6"
      [cellWidthCarousel]="100"
      [heightCarousel]="100"
      [isNote]="true"
      [limitUploadCount]="10"
      [chatType]="chatType"
    ></home365-multiple-files-upload>
  </div>

  <div class="footer">
    <div class="left">
      <span
        (click)="addAttachment()"
        matTooltip="{{'SERVICE.FILE_TOOLTIP' | translate}}"
        matTooltipClass="home365-black-tooltip"
        matTooltipPosition="below"
        matTooltipHideDelay="100"
      ><i class="fa-light fa-paperclip smaller"></i></span>
      <span
        (click)="addLink()"
        matTooltip="{{'SERVICE.LINK_TOOLTIP' | translate}}"
        matTooltipClass="home365-black-tooltip"
        matTooltipPosition="below"
        matTooltipHideDelay="100"
      ><i class="fa-light fa-link smaller"></i></span>
      <span
        (click)="showEmoji($event)"
        matTooltip="{{'SERVICE.EMOJI_TOOLTIP' | translate}}"
        matTooltipClass="home365-black-tooltip"
        matTooltipPosition="below"
        matTooltipHideDelay="100"
        #emojiLink
      ><i class="fa-light fa-face-smile smaller"></i></span>

      <emoji-mart
        class="emoji-picker"
        (emojiClick)="addEmoji($event)"
        [ngClass]="{'show-picker': emojiPickerVisible}"
        title="Pick your emoji…"
        emoji="point_up"
        #emojiPicker
      ></emoji-mart>



    </div>
    <div class="right">
      <button mat-button
              class="home365-button secondary"
              [ngClass]="{'disabled' : disabled || !canSave || savingNote || filesLoading || maxTextLength}"
              id="save_btn"
              (click)="save()"
              [disabled]="disabled || !canSave || savingNote || filesLoading || maxTextLength">
        {{buttonLabel}}
      </button>
    </div>
  </div>
</div>
<mat-error [@error] class="error" [ngClass]="{'show':maxTextLength}">{{('SERVICE.MAX_LENGTH_ERROR_TEXT' | translate).replace('*|MAX|*', maxlengthToShow)}}</mat-error>

